<template>
  <section id="expired" class="d-flex align-center flex-column mt-10">
    <v-icon color="error" size="large" class="text-h1 pb-4">mdi-alert-circle-outline</v-icon>
    <div class="text-h3 pb-6">Error in application</div>
    <div class="text-h5 pt-4 pb-4">A system error has occurred. We apologize for this inconvenience.</div>
    <div class="text-h5 pt-4 pb-4">
      You can report this issue to <span class="font-italic">{{ supportResource }}.</span>.
    </div>
    <div class="text-h5 pt-4 pb-16">You may also try to reload this application.</div>
    <div id="buttons">
      <v-btn-primary size="small" @click="reloadApp">Reload Application</v-btn-primary>
    </div>
  </section>
</template>

<script setup lang="ts">
const supportResource = import.meta.env.VITE_SUPPORT_CONTACT || "your IT support team";

const reloadApp = () => {
  window.location.href = window.location.href.split("?")[0].replace("/error", "");
};
</script>

<style scoped lang="scss">
.v-application {
  color: rgb(var(--v-theme-dark));
}

.v-application__wrap {
  gap: 1rem;
  //margin: 0 3rem;
}

.layout {
  justify-content: center !important;
  align-items: center !important;
}

section#expired {
  text-align: center;
  height: 100vh;
  width: 100%;
}
</style>
